export interface Faq {
  q: string
  a: string[]
}

export const faqs: Faq[] = [
  {
    q: 'Il materiale è in italiano o in inglese?',
    a: [
      'Il materiale didattico di ENGLISH TEACHER PRO™ è in inglese.',
      'Questo perché è stato creato per insegnanti di inglese e contiene materiale destinato a essere utilizzato direttamente durante le lezioni: lesson plans, exercises, speaking prompts, reading texts, writing activities, role plays, assessments e altre risorse didattiche.',
      'La pagina che stai leggendo è in italiano per permetterti di comprendere chiaramente cosa include il sistema prima dell’acquisto.',
    ],
  },
  {
    q: 'Devo seguire un programma scolastico specifico?',
    a: [
      'No.',
      'ENGLISH TEACHER PRO™ non è stato costruito intorno a un singolo curriculum nazionale.',
      'Il materiale è organizzato per livello, competenza e obiettivo linguistico, utilizzando livelli internazionalmente comprensibili come riferimento orientativo.',
      'Questo permette di selezionare e adattare le risorse al proprio contesto di insegnamento.',
    ],
  },
  {
    q: 'Posso utilizzarlo se insegno a studenti con livelli diversi?',
    a: [
      'Sì.',
      'Il sistema contiene materiale che copre diversi livelli di difficoltà, indicativamente da A1 a C1.',
      'Potrai selezionare le risorse più appropriate in base alle competenze e agli obiettivi dei tuoi studenti.',
    ],
  },
  {
    q: 'È adatto alle lezioni individuali?',
    a: [
      'Sì.',
      'Oltre al materiale principale riceverai 1-TO-1 & SMALL GROUP TEACHING KIT™, dedicato specificamente a lezioni individuali, tutoring, coppie e piccoli gruppi.',
    ],
  },
  {
    q: 'Posso utilizzarlo per le lezioni online?',
    a: [
      'Sì.',
      'Molte risorse possono essere utilizzate sia in presenza sia digitalmente e riceverai inoltre ONLINE ENGLISH CLASSROOM KIT™, dedicato specificamente all’insegnamento online.',
    ],
  },
  {
    q: 'Devo preparare io le attività?',
    a: [
      'La maggior parte del lavoro di costruzione è già stata fatta.',
      'Il sistema include contenuti, esercizi, prompts, strutture, attività e strumenti pronti da utilizzare.',
      'Naturalmente, come insegnante, potrai selezionare e adattare il materiale in funzione del livello, dell’età, degli obiettivi e delle necessità dei tuoi studenti.',
    ],
  },
  {
    q: 'È un corso per imparare a insegnare inglese?',
    a: [
      'No.',
      'ENGLISH TEACHER PRO™ non è un corso di formazione iniziale per diventare insegnante.',
      'È un sistema di materiali e strumenti pronti all’uso pensato per chi insegna inglese e vuole ridurre il tempo dedicato alla preparazione.',
    ],
  },
  {
    q: 'Dopo quanto tempo posso iniziare a utilizzarlo?',
    a: [
      'Immediatamente.',
      'Dopo aver ottenuto l’accesso potrai consultare il sistema, scegliere il livello e l’obiettivo su cui vuoi lavorare e iniziare a utilizzare le risorse disponibili.',
    ],
  },
  {
    q: 'Il pagamento è unico o è un abbonamento?',
    a: [
      'È un pagamento unico di 27€.',
      'Non ci sono rinnovi automatici né costi nascosti: accedi al sistema completo 6-in-1 e ai 5 bonus con un solo pagamento sicuro nella tua valuta.',
    ],
  },
  {
    q: 'Come funziona la garanzia se il sistema non fa per me?',
    a: [
      'Hai 14 giorni per esplorare lezioni, attività e strumenti di pianificazione e provarli nelle tue lezioni.',
      'Se ritieni che il sistema non sia adatto alle tue esigenze, ti basta contattarci entro 14 giorni per richiedere il rimborso secondo i termini della garanzia. Nessun rischio.',
    ],
  },
]
